import React from 'react';
import {Text, View} from 'react-native';

import {Code, Heading, Spacer} from '/component/base/Storybook';

import {EnterPinInput} from '../index';

import {styles} from './PinInput.story.style';

const DarkPinInput = () => {
  const rightPin = '2222';

  return (
    <>
      <Spacer size={30} />
      <Heading level={2}>Dark PinInput</Heading>
      <Spacer size={30} />
      <Text>
        <Code>EnterPinInput</Code> component is used to verify pin. The correct
        password is "2222". <Code>rightPin</Code> prop specifies the correct set
        of numbers.
      </Text>
      <Spacer size={30} />
      <View style={styles.containerLight}>
        <EnterPinInput
          theme="dark"
          textVariant="large"
          // @ts-expect-error TS(2322): Type 'string' is not assignable to type 'object'.
          enterTitle="Login with your 4 digit PIN"
          // @ts-expect-error TS(2322): Type 'string' is not assignable to type 'object'.
          errorTitle="Try Again"
          rightPin={rightPin}
        />
      </View>
      <Spacer size={30} />
      <Code>{'<EnterPinInput'}</Code>
      <Code>{' theme="dark"'}</Code>
      <Code>{' textVariant="large"'}</Code>
      <Code>{' enterTitle="Login with your 4 digit PIN"'}</Code>
      <Code>{' errorTitle="Try Again"'}</Code>
      <Code>{' rightPin="2222"'}</Code>
      <Code>{'/>'}</Code>
      <Spacer size={100} />
    </>
  );
};

export default DarkPinInput;
